<template>
  <div class="box-wrapper">
      <div class="buy-token">
        <div class="title">购买</div>
        <div class="content" v-if="!firstBuy">
          <input placeholder="输入购买数量(USDT为单位)" v-model="tokenAmount"/>
          <div>
            <button style="margin-right:24px;" @click="maxBuyToken">最大值</button>
            <button @click="buyToken">购买</button>
          </div>
        </div>
        <div class="content" v-else>
          <span style="margin: 12px">授权首次USDT购买</span>
          <button @click="approveSendUsdt">授权</button>
        </div>
      </div>  
      <div class="unlock-token">
        <div class="title">解锁</div>
        <div class="content">
          <div class="header">
            <span>解锁时间</span>
            <span>数量</span>
            <span>解锁</span>
          </div>
          <template v-if="unlocks.length !== 0">
            <div class= "table-content" v-for="(unlock, index) in unlocks" :key="index">
              <span>{{ unlock.time }}</span>
              <span>{{ unlock.tokenAmount }}</span>
              <span><button class="unlock-btn" @click="unLockToekn(index)">解锁</button></span>
            </div>
          </template>
        </div>
      </div>
      <div class="divide-unlock">
        <div class="title">分红</div>
        <div class="content">
          <div class="tab-title">
            <div class="tab1" :class="{'active-tab': tab1}" @click="tab1 = true">分红</div>
            <div class="tab2" :class="{'active-tab': !tab1}" @click="tab1 = false">质押代币到账号</div>
          </div>
          <div class="tab-content">
            <div v-show="tab1">
              <div class="tab-word">你还可以领取分红(USDT): {{ accountStatus.stillCanWithdrawDivide }} </div>
              <button @click="drawBouns">领取</button>
            </div>
            <div class="transfer-list" v-show="!tab1">
              <div class="tab-word" v-if="transferTime">转移代币时间: {{ transferTime }} </div>
              <div class="tab-word">已取消质押代币数量(HST): {{ unstaked.amount }} </div>
              <button :style="{ cursor: canTransfer() ? 'pointer' : 'not-allowed', color: canTransfer() ? '#222':'#d1c9c9'}" @click="drawToken">解锁</button>
            </div>
          </div>
        </div>
      </div>
      <div class="stake-unstake">
        <div class="title">质押</div>
        <div class="content">
          <div class="tab-title">
            <div class="tab1" :class="{'active-tab': tab2}" @click="tab2 = true">质押</div>
            <div class="tab2" :class="{'active-tab': !tab2}" @click="tab2 = false">取消质押</div>
          </div>
          <div class="tab-content">
            <div v-show="tab2">
              <input placeholder="请输入想要质押的代币数量" v-model="stakeNumber" class="tab-word"/>
              <div>
                <button style="margin-right:24px;" @click="maxStake">最大值</button>
                <button @click="stake">质押</button>
              </div>
            </div>
            <div v-show="!tab2">
              <input placeholder="请输入取消质押的代币数量" v-model="unstakeNumber" class="tab-word"/>
              <div>
                <button style="margin-right:24px;" @click="maxUnStake">最大值</button>
                <button @click="unstake">取消质押</button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { confirmingTransaction, toFix6 } from '../util';
export default {
  name: "FourLists",
  data() {
    return {
      unlocks: [{time: '', tokenAmount: ''}, {time: '', tokenAmount: ''}],
      stakeNumber: '',
      unstakeNumber: '',
      unstaked: {
        amount: 0,
        unlockTime: 0
      },
      tab1: true,         // 第一个box 分红与解锁
      tab2: true,         // 第二个box 质押与取消
      tokenAmount: '',    // 购买token数量
    }
  },
  computed: {
    ...mapState({
      usdtContract: state => state.usdtContract,
      hstContract: state => state.hstContract,
      myAddress: state => state.myAddress,
      usdtAddress: state => state.usdtAddress,
      hstAddress: state => state.hstAddress,
      accountStatus: state => state.accountStatus,
      referNameByte32: state => state.referNameByte32,
      firstBuy: state => state.firstBuy,
    }),
    transferTime() {
      if(Number(this.unstaked.unlockTime) == 0) return false;
      const date = new Date(this.unstaked.unlockTime * 1000);
      return date.toLocaleString();
    }
  },
  methods: {
    getLock1AndTime() {
      Promise
        .all([
          this.hstContract.methods.lock1(this.myAddress).call(),
          this.hstContract.methods.lock1time().call()
        ])
        .then(res => {
          const date = new Date(res[1] * 1000);
          this.$set(this.unlocks, 0,{
            utc: res[1] * 1000,
            time: date.toLocaleString(),
            tokenAmount: toFix6( res[0] )
          })
        });
    },

    getLock2AndTime() {
      Promise
        .all([
          this.hstContract.methods.lock2(this.myAddress).call(),
          this.hstContract.methods.lock2time().call()
        ])
        .then(res => {
          const date = new Date(res[1] * 1000);
          this.$set(this.unlocks, 1, {
            utc: res[1] * 1000,
            time: date.toLocaleString(),
            tokenAmount: toFix6( res[0] )
          })
        });
    },

    buyToken(amount) {
      const option = {
        group: 'notify'
      };
      if(!this.tokenAmount) {
        option.type = 'error';
        option.text = '请填写您要购买的金额数量';
        this.$notify(option);
        return;
      }
      const tokenAmount = Number(this.tokenAmount) * 1e6;
      this.hstContract.methods.buytoken(tokenAmount, this.referNameByte32).send()
        .on('transactionHash', hash => {
          confirmingTransaction(this, hash);
        })
        .then( res => {
          option.type = 'success';
          option.text = '您已成功购买价值' + this.tokenAmount + 'USDT的HST!';
          this.tokenAmount = '';
          this.$store.commit('unshiftTrxData', {
            id: res.transactionHash,
            status: 'ok'
          });
          this.$notify(option);
          this.$emit('refresh-balance');
          this.getLock1AndTime();
          this.getLock2AndTime();
        })
        .catch(err => {
          option.type = 'error';
          option.text = '您购买HST失败!请稍后再试!';
          this.$notify(option);
        });
    },

    approveSendUsdt() {
      // hst 21000000000000
      const option = {
        group: 'notify'
      };
      this.usdtContract.methods.approve(this.hstAddress, 21000000000000).send()
        .on('transactionHash', hash => {
          confirmingTransaction(this, hash);
        })
        .then( res => {
          option.type = 'success';
          option.text = '授权成功!';
          this.$notify(option);
          this.$store.commit('unshiftTrxData', {
            id: res.transactionHash,
            status: 'ok'
          });
          this.$store.commit('setFirstBuy', false);
        })
        .catch(err => {
          option.type = 'error';
          option.text = '授权失败!';
          this.$notify(option);
        });
    },

    unLockToekn(index) {
      const now = Date.now();
      const locktime = this.unlocks[index].utc;
      const option = {
        group: 'notify'
      };
      if (now < locktime) {
        this.$notify({
          group: 'notify',
          type: 'error',
          text: '未到解锁时间!解锁时间为:' + this.unlocks[index].time + ' !'
        })
      } else {
        this.hstContract.methods.unlockToken(index+1).send()
          .on('transactionHash', hash => {
            confirmingTransaction(this, hash);
          })
          .then( res => {
            option.type = 'success';
            option.text = '您已成功解锁'+this.unlocks[index].tokenAmount +'HST!';
            this.$notify(option);
            this.$store.commit('unshiftTrxData', {
              id: res.transactionHash,
              status: 'ok'
            });
            this.getLock1AndTime();
            this.getLock2AndTime();
          })
          .catch(err => {
            option.type = 'error';
            option.text = '解锁HST失败!请稍后再试!';
            this.$notify(option);
          });
      }
    },

    drawToken() {
      const option = {
        group: 'notify'
      };
      if(Number(this.unstaked.amount) === 0) {
        option.type = 'error';
        option.text = '没有可转HST!';
        this.$notify(option);
        return;
      }
      if(!this.canTransfer()) return;
      this.hstContract.methods.unstake_token().send()
        .on('transactionHash', hash => {
          confirmingTransaction(this, hash);
        })
        .then( res => {
          option.type = 'success';
          option.text = '您的HST已到账!';
          this.$store.commit('unshiftTrxData', {
            id: res.transactionHash,
            status: 'ok'
          });
          this.$notify(option);
          this.$emit('refresh-balance');
        })
        .catch(res => {
          option.type = 'error';
          option.text = '领取HST失败，请重试！';
          this.$notify(option);
        })
    },

    drawBouns() {
      const option = {
        group: 'notify'
      };
      if(Number(this.accountStatus.stillCanWithdrawDivide) == 0) {
        option.type = 'error';
        option.text = '没有可领取的分红';
        this.$notify(option);
        return;
      };
      this.hstContract.methods.claim().send()
        .on('transactionHash', hash => {
          confirmingTransaction(this, hash);
        })
        .then( res => {
          option.type = 'success';
          option.text = '您的分红(USDT)已到账!';
          this.$store.commit('unshiftTrxData', {
            id: res.transactionHash,
            status: 'ok'
          });
          this.$notify(option);
          this.$emit('refresh-balance');
        })
    },

    stake() {
      const option = {
        group: 'notify'
      };
      if(!this.stakeNumber) {
        option.type = 'error',
        option.text = '请填写您要质押的数量',
        this.$notify(option);
        return;
      }
      const stakeNumber = Number(this.stakeNumber);
      if(stakeNumber > this.accountStatus.hst) {
        option.type = 'error',
        option.text = 'HST数量不够，请购买HST',
        this.$notify(option);
        return;
      }
      this.hstContract.methods.stake(stakeNumber * 1e6).send()
        .on('transactionHash', hash => {
          confirmingTransaction(this, hash);
        })
        .then( res => {
          option.type = 'success',
          option.text = '您已成功质押' + stakeNumber + 'HST!',
          this.stakeNumber = '';
          this.$notify(option);
          this.$store.commit('unshiftTrxData', {
            id: res.transactionHash,
            status: 'ok'
          });
          this.refershStakeList();
          this.$emit('refresh-balance');
        })
        .catch(err => {
          option.type = 'error',
          option.text = '您质押HST失败!请稍后再试!',
          this.$notify(option);
        });
    },

    unstake() {
      const option = {
        group: 'notify'
      };
      if(!this.unstakeNumber) {
        option.type = 'error',
        option.text = '请填写您要取消质押的数量',
        this.$notify(option);
        return;
      }
      const unstakeNumber = Number(this.unstakeNumber);
      if(unstakeNumber > this.accountStatus.stakedToken) {
        option.type = 'error',
        option.text = '取消质押数量不能大于已质押数量',
        this.$notify(option);
        return;
      }
      this.hstContract.methods.unstake(unstakeNumber * 1e6).send()
        .on('transactionHash', hash => {
          confirmingTransaction(this, hash);
        })
        .then( res => {
          option.type = 'success',
          option.text = '您已成功取消质押' + unstakeNumber + 'HST!',
          this.unstakeNumber = '';
          this.$notify(option);
          this.$store.commit('unshiftTrxData', {
            id: res.transactionHash,
            status: 'ok'
          });
          this.$emit('refresh-balance');
          this.refershStakeList();
        })
        .catch(err => {
          option.type = 'error',
          option.text = '您取消质押失败!请稍后再试!',
          this.$notify(option);
        });
    },

    refershStakeList() {
      this.hstContract.methods.unstake_(this.myAddress).call()
        .then( res => {
          this.unstaked = {
            amount: toFix6(res.amount),
            unlockTime: res.unlockTime,
          };
        })
    },

    canTransfer() {
      const now = Date.now();
      if(this.unstaked.unlockTime * 1000 > now) return false;
      return true;
    },

    maxBuyToken() {
      this.tokenAmount = this.accountStatus.usdt;
    },

    maxStake() {
      this.stakeNumber = this.accountStatus.hst;
    },

    maxUnStake() {
      this.unstakeNumber = this.accountStatus.stakedToken;
    }
  }
}
</script>

<style lang="less" scoped>
@media (max-width: 600px) {
  .box-wrapper {
    display: flex;
    flex-direction: column;
    width: 96% !important;
    margin: 0!important;
    & > div {
      width: 100% !important;
      margin: 0 !important;
      margin-top: 24px !important;
    }
  }
}
.box-wrapper {
  display: flex;
  width: 800px;
  flex-wrap: wrap;
  box-sizing: border-box;
  margin-top: 80px;
  margin-left: -200px;
  & > div {
    width: 46%;
    border: 1px solid #ebeaee;
    box-shadow: 0 0 35px 0 rgba(0,0,0,.05);
    border-radius: 4px;
    margin: 12px;
    min-height: 240px;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      color: #a55aff;
      font-weight: 700;
      line-height: 1.5;
      height: 55px;
      border-bottom: 1px solid #ebeaee;
    }
  }
  .content {
    .tab-title {
      display: flex;
      background-color: #ebeaee;
      height: 55px;
      & > div {
        width: 48%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #334;
        font-size: 16px;
        font-weight: 700!important;
        cursor: pointer;
        position: relative;
      }
    }
    .active-tab {
      color: #a55aff !important;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 40%;
        margin-left: 30%;
        border-bottom: 2px solid #a55aff;
      }
    }
    .tab-word {
      word-wrap: break-word;
      word-break: break-all;
    }
    .tab-content > div {
      display: flex;
      flex-direction: column;
      flex-grow: 0;
      align-items: center;
      padding: 12px 0;
      .tab-word {
        margin: 12px 0;
      }
    }
  }
}
.buy-token {
  .content{
    padding: 12px 0;
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    align-items: center;
    input {
      margin: 12px;
    }
  }
}
.unlock-token {
  display: flex;
  flex-direction: column;
  .content {
    padding: 12px;
  }
  .header {
    letter-spacing: .3px;
    line-height: 22px;
    font-weight: 700;
    color: #708390;
    font-size: 14px;
  }
  .header, .table-content {
    display: flex;
    span {
      width: 25%;
      display: flex;
      align-items: center;
      margin: 4px 0;
    }
    span:first-child {
      width: 50%;
    }
  }
}
</style>    